import { useEffect, useState } from 'react';
import { useMQTTSensorData } from '../../utils/mqttUtils';

export default function MqttListener() {
    const [sensorData, setSensorData] = useState({
        humidity: [],
        temperature: [],
        moisture: [],
        distance: [],
        light: []
    });

    // This will maintain the MQTT connection and update the context
    const { isConnected, error } = useMQTTSensorData(
        'all', // We'll listen for all MAC addresses
        setSensorData
    );

    // Log connection status for debugging
    useEffect(() => {
        console.log('Global MQTT Connection Status:', { isConnected, error });
    }, [isConnected, error]);

    return null; // This component doesn't render anything
} 